module.exports = __webpack_public_path__ + "img/stena31.38486559.jpg";